import * as React from 'react';
import {
    ShowBase,
    useShowContext,
} from 'react-admin';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';

import { ProjectFileConfigAside } from './ProjectFileConfigAside';
import { ProjectFileConfig } from '@/types';

export const ProjectFileConfigShow = () => (
    <ShowBase>
        <ProjectFileConfigShowContent />
    </ShowBase>
);

const ProjectFileConfigShowContent = () => {
    const { record, isPending } = useShowContext<ProjectFileConfig>();
    if (isPending || !record) return null;

    return (
        <Box mt={2} mb={2} display="flex">
            <ProjectFileConfigAside />
            <Box flex="1">
                <Card>
                    <CardContent>
                        <Box display="flex">
                            <Box ml={2} flex="1" sx={{ mb: 2 }}>
                                <Typography variant="h5" sx={{ mb: 2 }}>
                                    {record.title}
                                </Typography>
                                <Typography variant="body1" component="div">
                                    <strong>Short Name:</strong> {record.short_name}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Template Path:</strong> {record.template_path}
                                </Typography>
                                {/* <Typography variant="body2" component="div">
                                    <strong>Folder Destination:</strong> {record.folder_destination}
                                </Typography> */}
                                <Typography variant="body2" component="div">
                                    <strong>File Extension:</strong> {record.file_extension}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Project File_type:</strong> {record.project_file_type}
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};
